import { createStore, applyMiddleware } from 'redux';
import RootReducer from './modules/rootReducer';
import RootSaga from './modules/rootSaga';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  RootReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware)
  )
);

sagaMiddleware.run(RootSaga);

export default store;
